// extracted by mini-css-extract-plugin
export default {"app":"XtrrMG","roundedBorders":"mvm79N"};